import { render, staticRenderFns } from "./kzqCmp.vue?vue&type=template&id=4ed557e2&scoped=true"
import script from "./kzqCmp.vue?vue&type=script&lang=js"
export * from "./kzqCmp.vue?vue&type=script&lang=js"
import style0 from "./kzqCmp.vue?vue&type=style&index=0&id=4ed557e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed557e2",
  null
  
)

export default component.exports